export default function PlatformPage({
  title,
  description = "",
  maxWidth = "max-w-[1200px]",
  children,
  headerExtra = null,
}) {
  return (
    <div className={`p-8 lg:p-12 ${maxWidth} mx-auto space-y-8`}>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="text-overline">Platform</div>
          <h1 className="font-heading text-4xl mt-2 tracking-tight font-medium">{title}</h1>
          {description ? (
            <p className="mt-3 text-sm text-[var(--text-secondary)] max-w-2xl leading-relaxed">{description}</p>
          ) : null}
        </div>
        {headerExtra}
      </div>
      {children}
    </div>
  );
}
